export const LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/sfio5nMTtdMQFgmLKeBBxC/Logo_(1)_1.png'

// Original generated background: distributed network routes along the lower band and far-left
// edge, small orange/green junction segments, quiet charcoal elsewhere. No text, people, or UI.
export const HERO_BG_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/dd3d7f45-a859-4916-9184-a97671726fab.jpg'

export const PORTFOLIO_URL =
  'https://www.websiteforge.com/custom-website-design-examples.html'

export const CUSTOMER_STORIES_URL =
  'https://www.websiteforge.com/Satisfied_Website_Customers.html'

export const PHONE_DISPLAY = '231-266-0606'
export const PHONE_HREF = 'tel:+12312660606'
export const SALES_EMAIL = 'sales@websiteforge.com'

export const navLinks = [
  { label: 'What we handle', href: '#services' },
  { label: 'Ecommerce', href: '#ecommerce' },
  { label: 'Our work', href: '#work' },
  { label: 'Support', href: '#support' },
]

// Shared header and footer navigation (in-page destinations).
export const headerNavLinks = [
  { label: 'Home', href: '#top' },
  { label: 'Solutions', href: '#services' },
  { label: 'Portfolio', href: '#portfolio' },
  { label: 'Why WebsiteForge', href: '#why-websiteforge' },
  { label: 'How Pricing Works', href: '#pricing' },
]

export const trustPoints = [
  {
    title: 'Since 2002',
    body: 'Experience across multiple generations of web technology.',
  },
  {
    title: '1,000+ websites',
    body: 'Custom builds, rebuilds, ecommerce stores, and long-term client work.',
  },
  {
    title: '100+ integrations',
    body: 'CRM, accounting, scheduling, inventory, billing, and other business systems.',
  },
  {
    title: '0% WebsiteForge transaction fees',
    body: 'Your processor charges its rate. WebsiteForge does not add a percentage of each order.',
  },
]

export const businessNeeds = [
  'Reach the right customers',
  'Turn interest into inquiries',
  'Sell and collect payment',
  'Keep customers informed',
  'Connect the tools you use',
]

export const systemCapabilities = [
  {
    id: 'website',
    title: 'Website & content',
    body: 'A custom website that explains what you offer and makes the next step clear.',
  },
  {
    id: 'seo',
    title: 'SEO & digital advertising',
    body: 'Help the right people find you through search, Google Ads, and social advertising.',
  },
  {
    id: 'leads',
    title: 'Leads & customer communication',
    body: 'Connect calls, forms, quotes, booking, text, and chat so inquiries keep moving.',
  },
  {
    id: 'ecommerce',
    title: 'Ecommerce & payments',
    body: 'Bring products, pricing, checkout, and customer accounts together around how you sell.',
  },
  {
    id: 'integrations',
    title: 'Integrations & automation',
    body: 'Connect CRM, billing, inventory, and other systems to reduce repeated work and manual entry.',
  },
  {
    id: 'hosting',
    title: 'Hosting, reporting & support',
    body: 'We keep things running, handle changes, and show you what is improving and what comes next.',
  },
]

export const expertiseRows = [
{
  id: 'stand',
  title: 'Attract the right customers.',
  body: 'We check actual search rankings, study competitors, and improve your pages and technical SEO. Content, Google Ads, and social advertising support the same goals.'
},
{
  id: 'capture',
  title: 'Capture and follow through.',
  body: 'Help customers inquire through forms, live chat, and AI-assisted answers. Connect quotes, bookings, and follow-up, with clear handoffs to your team.'
},
{
  id: 'connect',
  title: 'Cut the repeat work.',
  body: 'Connect your CRM, billing, scheduling, and order systems so information moves where it needs to go without being entered twice.'
},
{
  id: 'changed',
  title: 'Measure. Improve. Repeat.',
  body: "Monthly reports show the work completed, the results we're tracking, and what we'll improve next."
}];

export const automationSteps = [
  {
    id: 'capture',
    title: 'Capture and respond.',
    body: 'Forms, live chat, and AI-assisted answers help customers take the next step, with clear handoffs to your team.',
  },
  {
    id: 'moving',
    title: 'Keep the sale moving.',
    body: 'Connect quote requests, bookings, and follow-up around your sales process.',
  },
  {
    id: 'twice',
    title: 'Stop entering everything twice.',
    body: 'Link your CRM, billing, scheduling, and order systems so information moves where it needs to go.',
  },
]

export const ecommerceBenefits = [
  'Product options, bundles, and made-to-order items.',
  'Customer pricing, wholesale accounts, and quote-to-order.',
  'Connected inventory, payments, and fulfillment.',
]

// Real current desktop screenshots supplied by WebsiteForge. Each links to the client's live site.
// Note: the 6G Tools thumbnail was captured from a development host, but visitors are shown and
// linked to the live domain only.
export const projects = [
  {
    name: 'FSG Transport',
    displayUrl: 'FSGTransport.com',
    href: 'https://www.fsgtransport.com/',
    image: 'https://cdn.magicpatterns.com/uploads/vA6Tw6hX2D26bEmrWP3NAk/fsg-transport.png',
  },
  {
    name: "Kosin's Glass",
    displayUrl: 'KosinsGlass.com',
    href: 'https://www.kosinsglass.com/',
    image: 'https://cdn.magicpatterns.com/uploads/eNLMUeEtTJ5Vx7ssLwmSF5/kosins-glass.png',
  },
  {
    name: '6G Tools',
    displayUrl: '6GTools.com',
    href: 'https://www.6gtools.com/',
    image: 'https://cdn.magicpatterns.com/uploads/duAyWoLk6CMsSYqsFohDht/6g-tools-development.png',
  },
  {
    name: 'JAG Medical Solutions',
    displayUrl: 'JAGMedicalSolutions.com',
    href: 'https://www.jagmedicalsolutions.com/',
    image: 'https://cdn.magicpatterns.com/uploads/dRmWpTYoRDs4fzHhCJZrx2/jag-medical-solutions.png',
  },
]

export const supportColumns = [
  {
    id: 'upkeep',
    title: 'We handle the upkeep.',
    body: 'Managed hosting, SSL, backups, monitoring, and content changes.',
  },
  {
    id: 'improving',
    title: 'We keep improving.',
    body: 'SEO updates, campaign and conversion improvements, monthly reporting, and clear next steps.',
  },
  {
    id: 'grow',
    title: 'We grow with you.',
    body: 'New chat flows, integrations, and automation as your business needs change.',
  },
]

// Exact excerpts from testimonials published on https://www.websiteforge.com/
export const testimonials = [
  {
    quote: "The support I've received from Website Forge has been great.",
    name: 'Bruce Oliver',
  },
  {
    quote: 'We have since built several successful websites together.',
    name: 'Ginger Rushing',
  },
]

export const buyerQuestions = [
  {
    "q": "Do I need a new website to work with you?",
    "a": "Not necessarily. We start by reviewing your website and business goals. Then we recommend what to keep, improve, connect, or rebuild, so the work addresses what is actually holding you back."
  },
  {
    "q": "Can you help us get more leads, not just a new website?",
    "a": "Yes. We bring SEO, content, digital advertising, and lead capture into one plan. Our team directs the strategy and uses AI to get more done. Monthly reports show the work completed and the rankings, inquiries, or sales we're tracking."
  },
  {
    "q": "Can you connect the software we already use?",
    "a": "We build integrations for tools such as CRM, billing, inventory, and scheduling systems. We review your software and workflow first, then scope the connections and automation that will reduce repeat entry and keep information moving."
  },
  {
    "q": "Who handles updates and support after launch?",
    "a": "Our team stays involved. Send us the changes you need, and we handle the work covered by your plan, from content updates and hosting to ongoing improvements. As your needs grow, we can add new features, integrations, and automation."
  },
  {
    "q": "How much will it cost, and what's included?",
    "a": "Your proposal defines the build, ongoing services, timeline, and price before work begins. Scope depends on the design, features, marketing, and integrations you need. Ad spend, third-party costs, and larger additions are identified separately."
  }
];
